export const SALES_ANALYTICS_CACHE_TTL_MS = 15 * 60 * 1000;
export const SALES_ANALYTICS_MAX_CACHE_ENTRIES = 8;

export const buildSalesAnalyticsCacheKey = ({
  startDate,
  endDate,
  restaurantIds = [],
  groupBy = '',
}) => {
  const restaurants = [...restaurantIds].filter(Boolean).sort().join(',');
  return `${startDate}|${endDate}|${restaurants}|${groupBy || 'none'}`;
};

export const trimSalesAnalyticsCache = (cache, cacheKeys) => {
  const nextCache = { ...cache };
  const nextKeys = [...cacheKeys];

  while (nextKeys.length > SALES_ANALYTICS_MAX_CACHE_ENTRIES) {
    const oldestKey = nextKeys.shift();
    delete nextCache[oldestKey];
  }

  return { cache: nextCache, cacheKeys: nextKeys };
};

export const isSalesAnalyticsCacheFresh = (entry) =>
  Boolean(entry?.fetchedAt && Date.now() - entry.fetchedAt < SALES_ANALYTICS_CACHE_TTL_MS);

export const getDefaultRestaurant = (restaurants = []) =>
  restaurants.find((r) => r.restaurantName?.toLowerCase().includes('mcallen')) || restaurants[0];

export const getDefaultRestaurantIds = (restaurants = []) => {
  const defaultRestaurant = getDefaultRestaurant(restaurants);
  return defaultRestaurant ? [defaultRestaurant.restaurantGuid] : [];
};
